module.exports = __webpack_public_path__ + "img/dark-history.587d4ec3.png";